// Client for the home previews API (api/home_previews.php) — admin-manageable
// photo cards shown on Home.tsx under "The spaces / Everywhere you'll spend
// your stay". Each row's photo is a separate media_slots upload keyed
// home.preview.<id> — see buildHomePreviewMediaSlots() in mediaSlots.ts.

import { parseJsonResponse } from './apiFetch';
const API_BASE: string = import.meta.env.VITE_API_BASE ?? '/api';

export interface HomePreview {
  id: number;
  label: string;
  link: string;
  confirm_leave: 0 | 1;
  sort_order: number;
}

export interface HomePreviewInput {
  label: string;
  link: string;
  confirm_leave: boolean;
  sort_order: number;
}

export function homePreviewSlotKey(id: number): string {
  return `home.preview.${id}`;
}

export async function fetchHomePreviews(bustCache = false): Promise<HomePreview[]> {
  // bustCache: see the matching comment on fetchRooms() in roomsApi.ts.
  const qs = bustCache ? `&v=${Date.now()}` : '';
  const res = await fetch(`${API_BASE}/home_previews.php?action=list${qs}`);
  const data = await parseJsonResponse(res);
  if (!data.success) throw new Error(data.message ?? 'Failed to load home previews');
  return data.items;
}

export async function addHomePreview(input: HomePreviewInput, csrfToken: string): Promise<{ success: boolean; id?: number; message?: string }> {
  const res = await fetch(`${API_BASE}/home_previews.php?action=add`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...input, csrf_token: csrfToken }),
  });
  return parseJsonResponse(res);
}

export async function updateHomePreview(id: number, input: HomePreviewInput, csrfToken: string): Promise<{ success: boolean; message?: string }> {
  const res = await fetch(`${API_BASE}/home_previews.php?action=update`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, ...input, csrf_token: csrfToken }),
  });
  return parseJsonResponse(res);
}

export async function deleteHomePreview(id: number, csrfToken: string): Promise<{ success: boolean; message?: string }> {
  const res = await fetch(`${API_BASE}/home_previews.php?action=delete`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, csrf_token: csrfToken }),
  });
  return parseJsonResponse(res);
}
